import request from '@/utils/request'
// 报名列表
export function getSupplierRegistrationList(params) {
  return request({
    url: '/web/Supplier/list',
    method: 'get',
    params
  });
}

// 供应商
// 报名列表
export function getProjectList(data) {
  return request({
    url: '/web/Supplier/MyProject',
    method: 'get',
    params:data
  });
}
// 能否报名
export function getSupplierCanRegister(data) {
  return request({
    url: '/web/Supplier/CanRegister',
    method: 'get',
    params:data
  });
}
// 报名
export function postAddProjectSupplier(data) {
  return request({
    url: '/web/Supplier/AddProjectSupplier',
    method: 'post',
    data
  });
}

// 项目 流程节点
export function getProjectFlowNodes(params) {
  return request({
    url: '/web/Supplier/ProjectFlowNodes',
    method: 'get',
    params
  });
}

// 项目 公告查询 某一个类型的公告
export function getProjectNoticeByProjectId(params) {
  return request({
    url: '/web/Supplier/GetProjectNoticeByProjectId',
    method: 'get',
    params
  });
}
